export default __webpack_public_path__ + "img/651a85b30da6652b896e6fd77dfff06d.jpg";